import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { CampaignService } from '../../services/campaign.service';
import { Subject } from 'rxjs';
import { TicketComboSchema } from '../../structure/ticketing';

import * as DialogActions from 'app/dialog/features/dialog.actions';
import { Store } from '@ngrx/store';
import { DialogService } from 'app/dialog/services/dialog.service';
import { filter } from 'rxjs/operators';
import { selectTicketComboName, selectTicketComboCampaignName,selectTicketComboQuantity  } from '../../features/campaign.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-ticket-combo',
  templateUrl: './campaign-ticket-combo.component.html',
  styleUrls: ['./campaign-ticket-combo.component.scss']
})
export class CampaignTicketComboComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  @Input() option: any = null;

  get id(): UntypedFormControl {
    return this.option.get('id');
  }
  get ticketCombo(): UntypedFormArray {
    return this.option.get('ticketCombo');
  }

  public takeUntilSubject: Subject<any> = new Subject()
  public ticketQuantity = ''
  public ticketMultiplier = 0

  constructor(
    public store: Store,
    public formBuilder: UntypedFormBuilder,
    public campaignService: CampaignService,
    public dialogService: DialogService,
    public cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.dialogService.closeDialogSubject.pipe(
      filter(data => _.get(data, 'name', null) === 'ticketCombo'),
      filter(data => _.get(data, 'action', null) === 'add'),
      filter(data => _.get(data, 'value', false)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      const group = new UntypedFormGroup({});
      this.campaignService.generateForm(group, TicketComboSchema);
      this.campaignService.initializeForm(group, data.value, TicketComboSchema);
      this.ticketCombo.push(group);
      this.cdr.markForCheck();
    });

    this.dialogService.closeDialogSubject.pipe(
      filter(data => _.get(data, 'name', null) === 'ticketCombo'),
      filter(data => _.get(data, 'action', null) === 'edit'),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      const value = _.get(data, 'value', null);
      if(value) {
        this.campaignService.initializeForm(this.ticketCombo.controls[data.id] as UntypedFormGroup, value, TicketComboSchema);
        this.cdr.markForCheck();
      }
    });
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  getTicketComboName(ticket) {
    const campaignId = ticket.get('campaignId').value;
    const optionId = ticket.get('optionId').value;
    const count = ticket.get('count').value;
    return this.store.select(
      selectTicketComboName(campaignId, optionId, count)
    );
  }

  getTicketComboQuantity(ticket, multy = false) {
    const campaignId = ticket.get('campaignId').value;
    const optionId = ticket.get('optionId').value;
    const count = ticket.get('count').value;
    this.store.select(
      selectTicketComboQuantity(campaignId, optionId, count)
    ).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((item)=>{
      this.ticketMultiplier = item[0]
      this.ticketQuantity = item[1]
    });
    if(multy){
      return this.ticketMultiplier !== 0 ? `<div class="d-flex group-ticket-info__container px-2 py-1">
                                                <div class="group-ticket-info__icon mr-2 d-flex align-items-center">
                                                    <img src="img/svg/quickpay/group-ticket.svg" height="12" width="12">
                                                </div>
                                                <div class="group-ticket-info__content">x<span>${this.ticketMultiplier}</span></div>
                                            </div>` : " "
    }
    return this.ticketQuantity
  }

  getTicketComboCampaignName(ticket){
    const campaignId = ticket.get('campaignId').value;
    const optionId = ticket.get('optionId').value;
    const count = ticket.get('count').value;
    return this.store.select(
      selectTicketComboCampaignName(campaignId, optionId, count)
    );
  }


  addTicketCombo(initialState = {
    id: null,
    action: 'add'
  }) {
    const ticketCombo = this.option.get('ticketCombo');
    const action = DialogActions.openDialog({
      payload: {
        name: "ticketCombo",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState: {
          ...initialState,
          optionId: this.id.value,
          ticketCombo: ticketCombo.value
        }
      }
    });
    this.store.dispatch(action);
  }

  editTicketCombo(option, index) {
    const ticketCombo = this.option.get('ticketCombo');
    const action = DialogActions.openDialog({
      payload: {
        name: "ticketCombo",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState: {
          id: index,
          action: 'edit',
          option,
          optionId: this.id.value,
          ticketCombo: ticketCombo.value
        }
      }
    });
    this.store.dispatch(action);
  }

  dropOption(event) {
    moveItemInArray(this.ticketCombo.controls, event.previousIndex, event.currentIndex);
  }


  removeTicket(index) {
    this.ticketCombo.removeAt(index);
  }

}
